import { SelectionType } from "../../../../data";
export function showFreeHtml(freeHtml, market) {
    if (market && market.type === SelectionType.QA) {
        return undefined;
    }
    return freeHtml;
}
//# sourceMappingURL=showFreeHtml.js.map